(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-tabbing"] && !Shopify.designMode) return;
  try {
    
// --- State for each metaobject container ---
const cpkMetaState = {};

// --- Initialize Show More buttons ---
document.querySelectorAll('.cpk-show-more-btn').forEach(btn => {
  const containerId = btn.dataset.target;

  if (!cpkMetaState[containerId]) {
    const container = document.getElementById(containerId);
    cpkMetaState[containerId] = {
      page: 2, // first page already loaded
      maxPages: parseInt(btn.dataset.maxPages),
      firstPageHtml: container.innerHTML,
      initialNextUrl: btn.dataset.nextUrl
    };
  }

  btn.addEventListener('click', function() {
    loadMoreMetaObjects(this);
  });
});

// --- Initialize Show Less buttons ---
document.querySelectorAll('.cpk-show-less-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    showLessMetaObjects(this);
    
  });
});

// --- Load More Function ---
function loadMoreMetaObjects(button) {
  const containerId = button.dataset.target;
  const container = document.getElementById(containerId);
  if (!container) return;

  const state = cpkMetaState[containerId];
  const nextUrl = button.dataset.nextUrl;

  if (!nextUrl || state.page > state.maxPages) {
    button.style.display = 'none';
    const showLessBtn = document.querySelector(`.cpk-show-less-btn[data-target="${containerId}"]`);
    if (showLessBtn) showLessBtn.style.display = 'inline-block';
    return;
  }

  // --- Show loader ---
  const btnText = button.querySelector('.cpk-btn-text');
  const btnLoader = button.querySelector('.cpk-btn-loader');
  btnText.style.display = 'none';
  btnLoader.style.display = 'inline-block';

  fetch(nextUrl)
    .then(res => res.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const newItems = doc.getElementById(containerId);

      if (newItems) {
        Array.from(newItems.children).forEach((child, i) => {
          child.style.opacity = 0;
          child.style.transform = 'translateY(20px)';
          container.appendChild(child);

          // Animate
          requestAnimationFrame(() => {
            child.style.transition = 'all 0.4s ease';
            child.style.opacity = 1;
            child.style.transform = 'translateY(0)';
          });

          // Initialize GLightbox for new items only
          const link = child.querySelector('.glightbox');
          if (link) {
            GLightbox({ selector: `.glightbox[href="${link.getAttribute('href')}"]` });
          }
        });

        // Increment page
        state.page++;

        // Update nextUrl
        const nextBtn = doc.querySelector(`.cpk-show-more-btn[data-target="${containerId}"]`);
        if (nextBtn && nextBtn.dataset.nextUrl) {
          button.dataset.nextUrl = nextBtn.dataset.nextUrl;
        } else {
          // No more pages, hide show more & display show less
          button.style.display = 'none';
          const showLessBtn = document.querySelector(`.cpk-show-less-btn[data-target="${containerId}"]`);
          if (showLessBtn) showLessBtn.style.display = 'inline-block';
        }
      }

      // Hide loader
      btnLoader.style.display = 'none';
      btnText.style.display = 'inline-block';
    })
    .catch(err => {
      console.error('Error loading more:', err);
      btnLoader.style.display = 'none';
      btnText.style.display = 'inline-block';
    });
}

// --- Show Less Function ---
function showLessMetaObjects(button) {
  const containerId = button.dataset.target;
  const container = document.getElementById(containerId);
  if (!container || !cpkMetaState[containerId]) return;

  const state = cpkMetaState[containerId];
  const children = Array.from(container.children);

  // Animate collapse
  children.forEach((child, i) => {
    child.style.transition = `all 0.4s ease ${i * 0.05}s`;
    child.style.opacity = 0;
    child.style.transform = 'translateY(20px)';
  });

  setTimeout(() => {
    // Reset container to first page
    container.innerHTML = state.firstPageHtml;

    // Reset page
    state.page = 2;

    // Reset nextUrl
    const showMoreBtn = document.querySelector(`.cpk-show-more-btn[data-target="${containerId}"]`);
    if (showMoreBtn) {
      showMoreBtn.dataset.nextUrl = state.initialNextUrl;
      showMoreBtn.style.display = 'inline-block';
    }

    // Hide show less
    button.style.display = 'none';

    // Reinitialize GLightbox for first page
    container.querySelectorAll('.glightbox').forEach(link => {
      GLightbox({ selector: `.glightbox[href="${link.getAttribute('href')}"]` });
    });

    const galleryOFFSET = 80;
    const parentSectionGallery = button.closest(".cpk-our-gallery");
    if (parentSectionGallery) {
      const sectionTop = parentSectionGallery.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - galleryOFFSET,
        behavior: "smooth"
      });
    }

  }, 400 + children.length * 50);
}

// --- Tabs Logic ---
document.querySelectorAll('.cpk-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    // Remove active class from all tabs
    document.querySelectorAll('.cpk-tab').forEach(t => t.classList.remove('cpk-active'));
    tab.classList.add('cpk-active');

    // Hide all tab contents
    document.querySelectorAll('.cpk-tab-content').forEach(content => content.classList.remove('cpk-active'));

    // Show the clicked tab
    const tabId = tab.dataset.tab;
    document.getElementById(tabId).classList.add('cpk-active');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
              class StickyHeader extends HTMLElement {
                constructor() {
                  super();
                }
                
                connectedCallback() {
                  this.header = document.querySelector('.section-header');
                  this.headerIsAlwaysSticky =
                  this.getAttribute('data-sticky-type') === 'always' ||
                  this.getAttribute('data-sticky-type') === 'reduce-logo-size';
                  this.headerBounds = {};
                  
                  this.setHeaderHeight();
                  
                  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
                  
                  if (this.headerIsAlwaysSticky) {
                    this.header.classList.add('shopify-section-header-sticky');
                  }
                  
                  this.currentScrollTop = 0;
                  this.preventReveal = false;
                  this.predictiveSearch = this.querySelector('predictive-search');
                  
                  this.onScrollHandler = this.onScroll.bind(this);
                  this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
                  
                  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                  window.addEventListener('scroll', this.onScrollHandler, false);
                  
                  this.createObserver();
                }
                
                setHeaderHeight() {
                  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
                }
                
                disconnectedCallback() {
                  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                  window.removeEventListener('scroll', this.onScrollHandler);
                }
                
                createObserver() {
                  let observer = new IntersectionObserver((entries, observer) => {
                    this.headerBounds = entries[0].intersectionRect;
                    observer.disconnect();
                  });
                  
                  observer.observe(this.header);
                }
                
                onScroll() {
                  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                  
                  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
                  
                  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                    this.header.classList.add('scrolled-past-header');
                    if (this.preventHide) return;
                    requestAnimationFrame(this.hide.bind(this));
                  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                    this.header.classList.add('scrolled-past-header');
                    if (!this.preventReveal) {
                      requestAnimationFrame(this.reveal.bind(this));
                    } else {
                      window.clearTimeout(this.isScrolling);
                      
                      this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                      }, 66);
                      
                      requestAnimationFrame(this.hide.bind(this));
                    }
                  } else if (scrollTop <= this.headerBounds.top) {
                    this.header.classList.remove('scrolled-past-header');
                    requestAnimationFrame(this.reset.bind(this));
                  }
                  
                  this.currentScrollTop = scrollTop;
                }
                
                hide() {
                  if (this.headerIsAlwaysSticky) return;
                  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                  this.closeMenuDisclosure();
                  this.closeSearchModal();
                }
                
                reveal() {
                  if (this.headerIsAlwaysSticky) return;
                  this.header.classList.add('shopify-section-header-sticky', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                }
                
                reset() {
                  if (this.headerIsAlwaysSticky) return;
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                }
                
                closeMenuDisclosure() {
                  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
                  this.disclosures.forEach((disclosure) => disclosure.close());
                }
                
                closeSearchModal() {
                  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
                  this.searchModal.close(false);
                }
              }
              
              customElements.define('sticky-header', StickyHeader);
              
  } catch(e) { console.error(e); }
})();
})();
